import {
    PREMIUM_SUBSCRIPTION_MONTHLY_PRICE,
    PREMIUM_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT,
    PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE,
    PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE_WITH_VAT,
    PREMIUM_SUBSCRIPTION_YEARLY_PRICE,
    PREMIUM_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT,
} from '@app/common/src/constants/premium-subscription';
import { BillingPeriod } from '../../../models/functions/billing-period';

export const prices: Record<BillingPeriod, { withVat: string; withoutVat: string; label: string }> = {
    monthly: {
        withVat: PREMIUM_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT,
        withoutVat: PREMIUM_SUBSCRIPTION_MONTHLY_PRICE,
        label: 'paymentMonthly',
    },
    halfyearly: {
        withVat: PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE_WITH_VAT,
        withoutVat: PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE,
        label: 'paymentHalfyearly',
    },
    yearly: {
        withVat: PREMIUM_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT,
        withoutVat: PREMIUM_SUBSCRIPTION_YEARLY_PRICE,
        label: 'paymentYearly',
    },
};
// Prices are maintained as CZK display strings in the shared subscription constants.
const priceAmount = (price: string): number => Number.parseFloat(price.replace(/\s/g, '').replace(',', '.'));

export const getPriceComparison = (period: BillingPeriod, withVat = true) => {
    const priceKey = withVat ? 'withVat' : 'withoutVat';
    const months = { monthly: 1, halfyearly: 6, yearly: 12 }[period];
    const total = priceAmount(prices[period][priceKey]);
    const monthlyPaymentsTotal = priceAmount(prices.monthly[priceKey]) * months;
    return {
        total,
        monthlyEquivalent: total / months,
        savings: monthlyPaymentsTotal - total,
        monthlyPrice: priceAmount(prices.monthly[priceKey]),
        // The promotion is based on VAT-inclusive prices, independent of display mode.
        freeMonths: Math.floor(
            (priceAmount(prices.monthly.withVat) * months - priceAmount(prices[period].withVat)) /
                priceAmount(prices.monthly.withVat),
        ),
    };
};

export const featureKeys = [
    'portfolios',
    'trades',
    'dashboard',
    'importTrade',
    'taxReport',
    'dividends',
    'profitCompareWithIndex',
    'investown',
    'personalAssets',
    'leaderboard',
    'insideValue',
    'priceAlert',
];
